import type { ReactNode } from 'react'
import { SymoneMark } from './Icon'

// The centred card every signed-out screen uses (sign in, sign up, forgot/reset
// password, invite landing). Same markup and classes as LoginView.
export function AuthCard({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string
  subtitle?: ReactNode
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <div className="login">
      <div className="login-card">
        <div className="login-brand"><SymoneMark size={28} /> <span>Symone</span></div>
        <h1 className="login-title">{title}</h1>
        {subtitle && <p className="login-subtitle">{subtitle}</p>}
        {children}
        {footer && <div className="login-links">{footer}</div>}
      </div>
    </div>
  )
}
